import React from 'react';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import ImageV2 from 'components_v2/common/ImageV2';
// import ImageV2 from 'components_v2/common/ImageV2';
import s from './SectionHeader.scss';
import { IMAGE_URL } from '../../../constants';

function SectionHeader({
  title,
  icon,
  sponseredLogo,
  sponseredText,
  sponseredLink,
  path,
  children,
  ga4Type,
  isWapView,
  shouldNotlazyloadIcon,
  ish1,
}) {
  // const ImageElement = ImageV2;
  let sponsoredData = null;
  if (sponseredText && (sponseredLink || sponseredLogo)) {
    sponsoredData = (
      <div className={s.sponseredLogo}>
        <span className={s.line} /> {sponseredText}
        {sponseredLink ? (
          <Link to={sponseredLink} doNotChangeURL target="_blank">
            <img
              src={`${IMAGE_URL}msid-${sponseredLogo}.cms`}
              alt={sponseredText}
            />
          </Link>
        ) : (
          <>
            <span className={s.line} /> {sponseredText}
            <img
              src={`${IMAGE_URL}msid-${sponseredLogo}.cms`}
              alt={sponseredText}
            />
          </>
        )}
      </div>
    );
  }

  let linkhTagData = null;
  if (isWapView && path) {
    linkhTagData = (
      <Link
        className={s.titleWrap}
        to={path}
        target="_blank"
        ga4Data={
          ga4Type && [
            {
              event: 'user_click',
              type: `${ga4Type}`,
              category: 'heading_click',
            },
          ]
        }
      >
        {title} {path && <i className={s.arrow} />}
      </Link>
    );
  } else if (ish1) {
    linkhTagData = (
      <h1 className={s.titleWrap}>
        {title} {path && <i className={s.arrow} />}
      </h1>
    );
  } else {
    linkhTagData = (
      <h2 className={s.titleWrap}>
        {title} {path && <i className={s.arrow} />}
      </h2>
    );
  }

  return (
    <section className={s.secHeader}>
      <div className={s.left}>
        {icon && (
          <span className={s.hLeftIcon}>
            <ImageV2
              alt={title}
              lazyload={!shouldNotlazyloadIcon}
              offsetVertical={400}
              height={isWapView ? '44' : '60'}
              width={isWapView ? '44' : '60'}
              placeHolderSrc={`${IMAGE_URL}87458172.cms`}
              src={`${IMAGE_URL}msid-${icon}.cms`}
            />
            {/* <img
              src={`https://static.toiimg.com/photo/msid-${icon}.cms`}
              alt={title}
            /> */}
          </span>
        )}
        {linkhTagData}
        {sponsoredData}
        {React.isValidElement(children) && children}
      </div>
      {path &&
        !isWapView && (
          <Link
            to={path}
            target="_blank"
            ga4Data={
              ga4Type && [
                {
                  event: 'user_click',
                  type: `${ga4Type}`,
                  category: 'cta_click',
                  label: 'see_all',
                },
              ]
            }
          >
            <span className={s.seeAll}>See All</span>
          </Link>
        )}
    </section>
  );
}
SectionHeader.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  title: PropTypes.string,
};

SectionHeader.defaultProps = {
  title: '',
};

export default SectionHeader;
